import React, {Fragment, useEffect, useState} from "react"
import MetaTags from "react-meta-tags"
import {Container, Card, CardBody, Nav, NavItem, NavLink} from "reactstrap"
import classnames from "classnames"
import {withRouter} from "react-router"
import AddModule from "./AddModule"
import DataTableModuleSpec from "./DataTableModuleSpec"
import AffectationModuleSpec from "./AffectationModuleSpec"
import DataTableModule from "./DataTableModule"

const Module = props => {
    const [section, setSection] = useState(1)
    const [add, setAdd] = useState(0);
    const [cloture, setCloture] = useState(0);
    useEffect(async () => {
        var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
            user.sous_menu.some(subMenu => subMenu.sous_menu === "Modules")
        );
        setAdd(typeArticleSubMenu.sous_menu[0].add)
    }, [])
    const back = () => {
        setSection(1)
    }

    const renderBlock = section => {
        if (section === 1) {
            return <DataTableModule/>
        } else if (section === 2) {
            return <AddModule setSection={setSection} back={back}/>
        } else if (section === 3) {
            return <DataTableModuleSpec/>
        } else if (section === 4) {
            return <AffectationModuleSpec setSection={setSection} back={back}/>
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Module | Cresus </title>
                </MetaTags>
                <Container fluid>
                    <div>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    style={{cursor: "pointer"}}
                                    className={classnames({
                                        active: section === 1,
                                    })}
                                    onClick={() => {
                                        setSection(1)
                                    }}
                                >
                                    Module
                                </NavLink>
                            </NavItem>
                            {add === 1 ? (
                                <Fragment>
                                    {cloture != 1 ? (
                                        <NavItem>
                                            <NavLink
                                                style={{cursor: "pointer"}}
                                                className={classnames({
                                                    active: section === 2,
                                                })}
                                                onClick={() => {
                                                    setSection(2)
                                                }}
                                            >
                                                Ajouter module
                                            </NavLink>
                                        </NavItem>
                                    ) : (null)}
                                    <NavItem>
                                        <NavLink
                                            style={{cursor: "pointer"}}
                                            className={classnames({
                                                active: section === 3,
                                            })}
                                            onClick={() => {
                                                setSection(3)
                                            }}
                                        >
                                            Module/Spécialité
                                        </NavLink>
                                    </NavItem>
                                    {cloture != 1 ? (
                                        <NavItem>
                                            <NavLink
                                                style={{cursor: "pointer"}}
                                                className={classnames({
                                                    active: section === 4,
                                                })}
                                                onClick={() => {
                                                    setSection(4)
                                                }}
                                            >
                                                Affectation module/Spécialité
                                            </NavLink>
                                        </NavItem>
                                    ) : (null)}
                                </Fragment>

                            ) : (null)}
                        </Nav>
                        <Card>
                            <CardBody>{renderBlock(section)}</CardBody>
                        </Card>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Module)
